module.exports = __webpack_public_path__ + "static/oblakoder-home-6-5416f1de62eedfc1a86873a197138e94.png";